let html = `<div class="simple-button selector filter--back">
    <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="35" height="27" rx="1.5" stroke="currentColor" stroke-width="3"/>
        <rect x="6" y="7" width="25" height="3" fill="currentColor"/>
        <rect x="6" y="13" width="13" height="3" fill="currentColor"/>
        <rect x="6" y="19" width="19" height="3" fill="currentColor"/>
    </svg>
</div>`

export default html